module.exports = __webpack_public_path__ + "afac752c957c53e9af6d094de71e69c2.ttf";